export enum ListSectionType {
  BULLETS = 'BULLETS',
  NUMBERED = 'NUMBERED',
}
